import React from 'react';
import PropTypes from 'prop-types';

import Loading from '../../../components/loading';

import {
  getStorage,
  updateStorage
} from '../../../utils/storage';

import GsheetTable from './gtable';

import {
  fetchSuscResults,
  fetchDrugNames
} from './hivdb/load';

import PageHeader from '../../../components/page-header';
import Summary from './summary';
import GTable from '../../../components/gsheet/gtable';


export default class SuscResults extends React.Component {

  static contextTypes = {
    router: PropTypes.shape({
      replace: PropTypes.func.isRequired,
      push: PropTypes.func.isRequired
    }).isRequired
  };

  constructor() {
    super(...arguments);
    this.state = {
      loading: true,
      rawDataCollection: null,
    };
  }

  async componentDidMount() {
    this.setState({
      loading: true
    });

    const {location: {query}} = this.props;

    let {rawDataCollection} = (
      await getStorage(query.load));

    const {rawSequenceAlignmentPairs} = rawDataCollection;

    if (!rawDataCollection.hasRawSuscResults) {
      rawDataCollection.rawSuscResults = await fetchSuscResults(rawSequenceAlignmentPairs);
    }

    rawDataCollection = await fetchDrugNames(rawDataCollection);

    this.setState({
      rawDataCollection,
      loading: false,
    });
  }

  async handleUpdate(rawDataCollection) {
    this.setState({
      loading: true,
    });

    await this.handleSave();

    this.setState({
      rawDataCollection,
      loading: false,
    });
  }

  async handleSave() {
    const {location: {pathname}} = this.props;
    const {rawDataCollection} = this.state;

    const state = {
      pathname: pathname,
      rawDataCollection
    };
    const load = await updateStorage(state);
    return load;
  }

  async handleSubmit(e) {
    e && e.preventDefault();

    const load = await this.handleSave();
    this.context.router.push({
      pathname: '/wizard/finish',
      query: {load}
    });
  }

  get gsheet_table() {
    const {rawDataCollection} = this.state;

    return (
      <GsheetTable
       rawDataCollection={rawDataCollection}
       onUpdate={this.handleUpdate.bind(this)}
       onSubmit={this.handleSubmit.bind(this)}
      />
    );
  }

  render() {
    const {loading} = this.state;
    if(loading) {
      return (<Loading />);
    }

    const {rawDataCollection} = this.state;

    return (
      <div>
        <PageHeader references={rawDataCollection.references} />
        <Summary rawDataCollection={rawDataCollection} />
        {this.gsheet_table}
        <GTable
         spreadsheet_id={rawDataCollection.spreadsheet_id}
         sheet_id={rawDataCollection.sheet_id}
         ></GTable>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/susc-results/index.js